import { BaseApi } from '@/helpers/base-api'

export default class ClientApi extends BaseApi {
  constructor () {
    super('/api/v1/clients')
    this.errorMessage = 'There was an issue when trying to fetch the clients. If this error persists, please contact our support.'
  }

  public getAllClients = (query: string): Promise<ClientDto[]> => this.instance.get(`${query}`)
  public getClientCount = (): Promise<CountDto[]> => this.instance.get('/count')
  public getClient = (clientId: string): Promise<ClientDetailsDto> => this.instance.get(`/${clientId}`)
  public getClientInstallations = (clientId: string): Promise<any> => this.instance.get(`/${clientId}/installations`)
  public getClientCredit = (clientId: string): Promise<ClientCreditDto> => this.instance.get(`/${clientId}/credit`)
  public createCreditDeposit = (clientId: string, data: Record<string, unknown>): Promise<ClientCreditLedgerEntryDto> => this.instance.post(`/${clientId}/credit/deposit`, data)
  public createCreditRefund = (clientId: string, data: Record<string, unknown>): Promise<ClientCreditLedgerEntryDto> => this.instance.post(`/${clientId}/credit/refund`, data)
  
  public createClient = (data: Record<string, unknown>): Promise<any> => this.instance.post('', data)
  public checkForDuplicateContacs = (data: Record<string, unknown>): Promise<string> => this.instance.post(`/check/duplicate/contacts`, data)

  public updateClient = (clientId: string, data: Record<string, unknown>): Promise<string> => this.instance.patch(`/${clientId}`, data)

  public deleteClient = (clientId: string): Promise<string> => this.instance.delete(`/${clientId}`)

}
